import React from 'react';
import PropTypes from 'prop-types';
import compact from 'lodash/compact';
import { Helmet } from 'react-helmet';

import useSentinelTeam from 'hooks/useSentinelTeam';
import useIsOutsideTeamScope from 'hooks/useIsOutsideTeamScope';

export default function PageHead({ titleParts }) {
  const { name } = useSentinelTeam();
  // The last-viewed team stays in context on the All Teams pages; leave it
  // out of the tab title there, same as BrandInfo.
  const isOutsideTeamScope = useIsOutsideTeamScope();
  const title = compact([...titleParts, !isOutsideTeamScope && name]).join(
    ' • ',
  );
  return (
    <Helmet>
      <title>{title}</title>
    </Helmet>
  );
}

PageHead.propTypes = {
  titleParts: PropTypes.arrayOf(PropTypes.string).isRequired,
};
